module.exports = __webpack_public_path__ + "img/117.7d818a95.jpg";